/// <amd-module name="Pipeline/Analytics/PipelineStepsDurationCard/Actions/PipelineStepsDurationCardActions" />
import { PipelineReportBaseActions } from "Pipeline/Analytics/Common/Actions/PipelineReportBaseActions";
import { IStageMetrics } from "Pipeline/Analytics/Common/Types";
import { IPipelineStepDurationTrend, IStageStepsDurationData } from "Pipeline/Analytics/PipelineStepsDurationCard/Types";
import { Action } from "VSS/Reflux/Action";

export class PipelineStepsDurationCardActions extends PipelineReportBaseActions<IPipelineStepDurationTrend[]> {
    public selectStageAction: Action<IStageMetrics> = new Action<IStageMetrics>();
    public updateTopStepsDurationDataAction: Action<IStageStepsDurationData> = new Action<IStageStepsDurationData>();
}
